<template>
  <div class="palm0">
    <el-container>
      <!-- 页头 -->
      <el-header>
        <div class="maintitle">
          <img src="../../assets/img/palmmain1.png" @click="palm0" />
          <div class="active" @click="palm0">首页</div>
          <div @click="palm1">产品介绍</div>
          <div @click="palm2">功能介绍</div>
          <div @click="palm3">下载</div>
        </div>
      </el-header>
      <el-main>
        <div class="palmmain"></div>
        <div class="maininfo">
          <div class="titel">新版特性</div>
          <div class="card1">
            <div class="val">
              <img src="../../assets/img/palm0_5.png" />
              <div class="tal">多类型账号登录</div>
              <div class="tel">
                <div></div>
                <div>
                  支持连锁在线支付预留手机号登录，该账号可查看连锁下的所有场所信息
                </div>
              </div>
              <div class="tel">
                <div></div>
                <div>
                  支持非经营者用户手机号登录，该账号可查看资讯信息，以及发布求购、出售、招聘等信息
                </div>
              </div>
            </div>
            <img src="../../assets/img/palm0_1.png" />
          </div>
          <div class="card2">
            <img src="../../assets/img/palm0_2.png" />
            <div class="val">
              <img src="../../assets/img/palm0_6.png" />
              <div class="tal">经营数据优化</div>
              <div class="tel">
                <div></div>
                <div>
                  多场所列表可直接查看该账号关联的所有场所当前上座率、今日上机人次、今日收入信息
                </div>
              </div>
              <div class="tel">
                <div></div>
                <div>
                  场所营业收入、在线支付收入提供月收入对比和日均收入对比
                </div>
              </div>
              <div class="tel">
                <div></div>
                <div>提供会员新增、网费赠送数据</div>
              </div>
              <div class="tel">
                <div></div>
                <div>数据查询延长至近3个月</div>
              </div>
            </div>
          </div>
          <div class="card3">
            <div class="val">
              <img src="../../assets/img/palm0_7.png" />
              <div class="tal">个性化设置</div>
              <div class="tel">
                <div></div>
                <div>
                  <div class="teltext1">阈值设置</div>
                  <div class="teltext2">
                    对上座率、日营业收入、日在线支付收入设置参考值和预警值，方便数据对比和预警信息推送
                  </div>
                </div>
              </div>
              <div class="tel">
                <div></div>
                <div>
                  <div class="teltext1">面板数据自定义</div>
                  <div class="teltext2">场所管理面板顶部数据支持自定义设置</div>
                </div>
              </div>
            </div>
            <img src="../../assets/img/palm0_3.png" />
          </div>
          <div class="card4">
            <img src="../../assets/img/palm0_4.png" />
            <div class="val">
              <img src="../../assets/img/palm0_8.png" />
              <div class="tal">资讯板块</div>
              <div class="tel">
                <div></div>
                <div>支持发布求购、出售、招聘等信息，了解行业最新资讯</div>
              </div>
              <div class="tel">
                <div></div>
                <div>
                  发布的招聘信息将同时推送至招聘区域下的“去上网APP”用户，为场所提供更便捷、更有效的招聘信息传播渠道
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <!-- 底部 -->
      <el-footer>
        <div class="fotter">
          <div class="fotterdiv">
            <div class="yuedong">
              <img src="../../assets/img/palmfooter.png" />
              <div class="text1">
                © Copyright {{currentYear}} yedone.com all rights reserved.
                渝网文[2013]0887-006号
              </div>
              <div class="text2">
                经营许可证：渝B2-20190234&nbsp;&nbsp;|&nbsp;&nbsp;<span @click="zhizhao">营业执照</span><br />渝ICP备09014244号-16
              </div>
              <div class="text3">
                <img src="../../assets/img/guohui.png" />
                <div class="text3tel" @click="beian">
                  渝公网安备 50010802002169号
                </div>
              </div>
            </div>
            <div class="bor">
              <div class="bor1"></div>
              <div class="bor2"></div>
            </div>
            <div class="contactUs">
              <div class="women">联系我们</div>
              <div class="phone">
                <div class="dianhua1">
                  <div>客服电话（24h）</div>
                  <div>400-680-8811</div>
                </div>
                <div class="dianhua2">
                  <div>商务电话（工作日09:00-18:00）</div>
                  <div>023-68636622</div>
                </div>
              </div>
              <div class="phone2">
                <div class="dianhua1">
                  <div>客服QQ（24h）</div>
                  <div>4006808811</div>
                </div>
                <div class="dianhua2">
                  <div>公司地址</div>
                  <div>重庆市南岸区南城大道199号正联大厦3楼</div>
                </div>
              </div>
            </div>
            <div class="attention">
              <div class="women">关注我们</div>
              <div class="erweima">
                <div class="fuwu">
                  <img src="../../assets/img/qushangwang.png" />
                  <div>去上网APP微信服务号</div>
                </div>
                <div class="gongzong">
                  <img src="../../assets/img/baquan.jpg" />
                  <div>8圈计费微信公众号</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "palm0",
  data() {
    return {};
  },
  methods: {
    //跳转首页
    palm0() {
      this.$router.push("/palm0");
    },
    //跳转产品介绍
    palm1() {
      this.$router.push("/palm1");
    },
    //跳转功能介绍
    palm2() {
      this.$router.push("/palm2");
    },
    //跳转下载
    palm3() {
      this.$router.push("/palm3");
    },
    //跳转备案
    beian() {
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010802002169"
      );
    },
    //跳转营业执照
    zhizhao(){
      let routeData = this.$router.resolve('/yinye');
      window.open(routeData.href, '_blank');
    }
  },
  mounted() {
    if (
      /Android|webOS|iPhone|iPod|BlackBerry|Harmony/i.test(navigator.userAgent)
    ) {
      //移动设备打开的网页，缩放页面尺寸
      /*
  		var clientWidth = document.body.clientWidth;
  		var rate = clientWidth / 1920;
  		*/
      var rate = 0.1;
      var meta = document.getElementsByTagName("meta");
      meta["viewport"].setAttribute(
        "content",
        "width=device-width,initial-scale=" + rate
      );
    }
  },
  //获取当前年份
  computed:{
    currentYear(){
      return new Date().getFullYear();
    }
  }
};
</script>
<style lang="less" scoped>
/* 页头样式 */
.el-header {
  width: 100%;
  min-width: 1200px;
  height: 80px !important;
  box-sizing: border-box;
  padding: 16px 0 0;
  margin: 0 auto;
  .maintitle {
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 0 auto;
    > img {
      width: 148px;
      height: 48px;
      margin-right: 50px;
      &:hover {
        cursor: pointer;
      }
    }
    > div {
      width: 72px;
      height: 27px;
      text-align: center;
      font-size: 18px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      line-height: 27px;
      color: #626778;
      margin-left: 80px;
      &:hover {
        cursor: pointer;
      }
    }
    .active {
      opacity: 1;
      position: relative;
      color: #0e6eff;
      &::after {
        content: "";
        position: absolute;
        width: 30px;
        height: 4px;
        background: #0e6eff;
        opacity: 1;
        bottom: -10px;
        left: 50%;
        transform: translate(-50%, 50%);
      }
    }
  }
}
.el-main {
  width: 100%;
  min-width: 1200px;
  background: #f4f5f9;
  padding: 0;
  margin: 0 auto;
  .palmmain {
    margin: 0 auto;
    height: 460px;
    background-image: url(../../assets/img/palm0back.png);
    background-size: cover;
    /* 将背景图片等比缩放填满整个容器 */
    background-repeat: no-repeat;
    background-position: center;
  }
  .maininfo {
    width: 1200px;
    padding: 60px 0 80px;
    margin: 0 auto;
    .titel {
      width: 310px;
      height: 54px;
      font-size: 36px;
      font-family: Source Han Sans SC-Bold, Source Han Sans SC;
      font-weight: bold;
      color: #2d394b;
    }
    .card1 {
      width: 1200px;
      background: #ffffff;
      border-radius: 16px;
      padding: 20px 80px;
      margin-top: 30px;
      box-sizing: border-box;
      display: flex;
      .val {
        margin-top: 118px;
        > img {
          width: 72px;
          height: 72px;
        }
        .tal {
          margin-top: 12px;
          width: 356px;
          height: 59px;
          font-size: 40px;
          font-family: Source Han Sans SC-Medium, Source Han Sans SC;
          font-weight: 500;
          color: #2d394b;
        }
        .tel {
          display: flex;
          width: 502px;
          margin-top: 30px;
          & div:first-child {
            width: 14px;
            height: 14px;
            min-width: 14px;
            min-height: 14px;
            background: linear-gradient(135deg, #72c5ff 0%, #3d88ff 100%);
            border-radius: 50%;
            margin: 11px 8px 0 0;
          }
          & div:last-child {
            font-size: 24px;
            line-height: 36px;
            font-family: Source Han Sans SC-Regular, Source Han Sans SC;
            font-weight: 400;
            color: #626778;
          }
        }
      }
      > img {
        width: 410px;
        height: 712px;
        margin-left: 128px;
      }
    }
    .card2 {
      width: 1200px;
      background: #ffffff;
      border-radius: 16px;
      padding: 20px;
      margin-top: 30px;
      box-sizing: border-box;
      display: flex;
      > img {
        width: 605px;
        height: 712px;
      }
      .val {
        margin: 75px 0 0 33px;
        > img {
          width: 72px;
          height: 72px;
        }
        .tal {
          margin-top: 12px;
          width: 356px;
          height: 59px;
          font-size: 40px;
          font-family: Source Han Sans SC-Medium, Source Han Sans SC;
          font-weight: 500;
          color: #2d394b;
        }
        .tel {
          display: flex;
          width: 462px;
          margin-top: 30px;
          & div:first-child {
            width: 14px;
            height: 14px;
            min-width: 14px;
            min-height: 14px;
            background: linear-gradient(135deg, #72c5ff 0%, #3d88ff 100%);
            border-radius: 50%;
            margin: 11px 8px 0 0;
          }
          & div:last-child {
            font-size: 24px;
            line-height: 36px;
            font-family: Source Han Sans SC-Regular, Source Han Sans SC;
            font-weight: 400;
            color: #626778;
          }
        }
      }
    }
    .card3 {
      width: 1200px;
      background: #ffffff;
      border-radius: 16px;
      padding: 20px 20px 20px 80px;
      margin-top: 30px;
      box-sizing: border-box;
      display: flex;
      .val {
        margin-top: 108px;
        > img {
          width: 72px;
          height: 72px;
        }
        .tal {
          margin-top: 12px;
          width: 356px;
          height: 59px;
          font-size: 40px;
          font-family: Source Han Sans SC-Medium, Source Han Sans SC;
          font-weight: 500;
          color: #2d394b;
        }
        .tel {
          display: flex;
          width: 424px;
          margin-top: 30px;
          & > div:first-child {
            width: 14px;
            height: 14px;
            min-width: 14px;
            min-height: 14px;
            background: linear-gradient(135deg, #72c5ff 0%, #3d88ff 100%);
            border-radius: 50%;
            margin: 11px 10px 0 0;
          }
          & > div:last-child {
            .teltext1 {
              height: 36px;
              font-size: 24px;
              font-family: Source Han Sans SC-Regular, Source Han Sans SC;
              font-weight: 400;
              color: #2d394b;
            }
            .teltext2 {
              font-size: 18px;
              line-height: 36px;
              font-family: Source Han Sans SC-Normal, Source Han Sans SC;
              font-weight: 400;
              color: #818697;
              margin-top: 10px;
            }
          }
        }
      }
      > img {
        width: 570px;
        height: 712px;
        margin-left: 106px;
      }
    }
    .card4 {
      width: 1200px;
      background: #ffffff;
      border-radius: 16px;
      padding: 20px;
      margin-top: 30px;
      box-sizing: border-box;
      display: flex;
      > img {
        width: 570px;
        height: 712px;
      }
      .val {
        margin: 112px 0 0 28px;
        > img {
          width: 72px;
          height: 72px;
        }
        .tal {
          margin-top: 12px;
          width: 356px;
          height: 59px;
          font-size: 40px;
          font-family: Source Han Sans SC-Medium, Source Han Sans SC;
          font-weight: 500;
          color: #2d394b;
        }
        .tel {
          display: flex;
          width: 502px;
          margin-top: 30px;
          & div:first-child {
            width: 14px;
            height: 14px;
            min-width: 14px;
            min-height: 14px;
            background: linear-gradient(135deg, #72c5ff 0%, #3d88ff 100%);
            border-radius: 50%;
            margin: 11px 8px 0 0;
          }
          & div:last-child {
            font-size: 24px;
            line-height: 36px;
            font-family: Source Han Sans SC-Regular, Source Han Sans SC;
            font-weight: 400;
            color: #626778;
          }
        }
      }
    }
  }
}
/* 底部 */
.el-footer {
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  padding: 0;
  .fotter {
    height: 338px;
    background: #0b192b;
    padding-top: 51px;
    box-sizing: border-box;
    .fotterdiv {
      width: 1200px;
      height: 225px;
      margin: 0 auto;
      display: flex;
      .yuedong {
        width: 273px;
        height: 225px;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 21px;
        color: #626778;
        > img {
          width: 148px;
          height: 48px;
        }
        .text1 {
          margin-top: 37px;
        }
        .text2 {
          margin-top: 14px;
          span:hover{cursor: pointer;color: #ffffff;}
        }
        .text3 {
          margin-top: 14px;
          display: flex;
          justify-items: center;
          img {
            margin-right: 10px;
          }
          .text3tel {
            &:hover {
              cursor: pointer;
              color: #ffffff;
            }
          }
        }
      }
      .bor {
        width: 1px;
        height: 225px;
        margin-left: 36px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .bor1 {
          flex: 1;
        }
        .bor2 {
          height: 120px;
          border: 1px solid #1b2c43;
        }
      }
      .contactUs {
        width: 475px;
        height: 218px;
        margin-left: 50px;
        margin-top: 9px;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        line-height: 18px;
        color: #ffffff;
        .women {
          width: 80px;
          height: 29px;
        }
        .phone,
        .phone2 {
          margin-top: 57px;
          display: flex;
          .dianhua1,
          .dianhua2 {
            div:nth-child(1) {
              height: 20px;
              font-size: 14px;
              font-weight: 400;
              color: #626778;
            }
            div:nth-child(2) {
              height: 22px;
              font-size: 18px;
              font-family: DIN;
              color: #ffffff;
              margin-top: 8px;
            }
          }
          .dianhua1 {
            width: 124px;
          }
          .dianhua2 {
            margin-left: 52px;
          }
        }
        .phone2 {
          margin-top: 30px;
          .dianhua2 div:nth-child(2) {
            font-family: Source Han Sans SC;
            font-size: 16px;
          }
        }
      }
      .attention {
        width: 298px;
        height: 218px;
        margin-left: 67px;
        margin-top: 9px;
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        line-height: 18px;
        color: #ffffff;
        .women {
          width: 80px;
          height: 29px;
          margin-left: 10px;
        }
        .erweima {
          display: flex;
          margin-top: 51px;
          .fuwu,
          .gongzong {
            font-size: 14px;
            font-weight: 400;
            color: #626778;
            text-align: center;
            > img {
              width: 110px;
              height: 110px;
            }
            > div {
              margin-top: 8px;
            }
          }
          .gongzong {
            margin-left: 38px;
          }
        }
      }
    }
  }
}
</style>
